
document.addEventListener('DOMContentLoaded', function () {
  if (window.__POOL_GLOSSARY_INITED__) {
    console.warn('[glossary] already initialized; skipping');
    return;
  }
  window.__POOL_GLOSSARY_INITED__ = true;

  const glossaryInput   = document.getElementById('glossaryInput');
  const suggestionsList = document.getElementById('suggestionsList');
  const glossaryDisplay = document.getElementById('glossaryDisplay');
  const loadMoreBtn     = document.getElementById('loadMore');
  let   loadAllBtn      = document.getElementById('loadAll'); // <-- let, so we can create if missing
  const glossaryClear   = document.getElementById('glossaryClear'); // NEW: clear button, if present

  // sticky bar (supports either class name)
  const LETTER_BAR      = document.querySelector('.letter-bar') || document.querySelector('.letter-box');
  const LETTER_ANCHORS  = document.querySelectorAll('.letter-box a, .letter-bar a');

 function clearActiveLetter() {
  document.querySelectorAll('.letter-box.is-active').forEach(box =>
    box.classList.remove('is-active')
  );
}

function setActiveLetter(letter) {
  const targetLetter = (letter || 'ALL').toUpperCase();

  LETTER_ANCHORS.forEach(link => {
    const box = link.closest('.letter-box');
    if (!box) return;

    const linkLetter = (link.dataset.letter || 'ALL').toUpperCase();
    box.classList.toggle('is-active', linkLetter === targetLetter);
  });
}

function initScrollSpy() {
  if (!LETTER_BAR || !glossaryDisplay) return;

  function getSections() {
    return Array.from(glossaryDisplay.querySelectorAll('.letter-section'));
  }

  function getLetterFromSection(section) {
    const heading = section.querySelector('.letter-title');
    if (!heading) return null;

    if (heading.id && heading.id.startsWith('letter-')) {
      return heading.id.replace('letter-', '').toUpperCase();
    }

    return (heading.textContent || '').trim().charAt(0).toUpperCase();
  }

  function onScroll() {
    const sections = getSections();
    if (!sections.length) return;

    const scrollPoint = window.pageYOffset + 290;
    const firstSectionTop = sections[0].getBoundingClientRect().top + window.pageYOffset;

    let currentLetter = null;

    if (scrollPoint < firstSectionTop) {
      clearActiveLetter();
      return;
    }

    for (let i = 0; i < sections.length; i++) {
      const sectionTop = sections[i].getBoundingClientRect().top + window.pageYOffset;

      if (scrollPoint >= sectionTop) {
        currentLetter = getLetterFromSection(sections[i]);
      } else {
        break;
      }
    }

    if (currentLetter) {
      setActiveLetter(currentLetter);
    } else {
      clearActiveLetter();
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
}



  if (!glossaryInput || !suggestionsList || !glossaryDisplay || !loadMoreBtn) {
    console.error('Glossary: required elements not found in DOM.');
    return;
  }

  // Ensure #loadAll exists inside .glossary-buttons, to the right of #loadMore
  (function ensureLoadAllButton(){
    const buttonsWrap = document.querySelector('.glossary-buttons');
    if (!loadAllBtn && buttonsWrap) {
      const btn = document.createElement('button');
      btn.id = 'loadAll';
      btn.type = 'button';
      // mirror loadMore classes if any; fallback to a sane default
      btn.className = loadMoreBtn.className || 'button';
      btn.textContent = 'Load All';
      // place to the right of loadMore
      loadMoreBtn.insertAdjacentElement('afterend', btn);
      loadAllBtn = btn;
    }
  })();

  // Point directly to Shopify asset
  const GLOSSARY_URL = "//claruspool.com/cdn/shop/t/4/assets/pool-spa-glossary.json?v=167515116811395250551758299988";

  const renderedLetters = new Set();
  let allEntries = []; // entire glossary JSON
  let searchT;         // debounce timer
  let exactMode = false; // NEW: when true, we require an exact term match for search view

  // --- Delegated handler for suggestion list (use mousedown) ---
  suggestionsList.addEventListener('mousedown', (e) => {
    const li = e.target.closest('.glossary-suggestion');
    if (!li) return;

    // Prevent input from stealing focus / triggering blur mechanics
    e.preventDefault();

    const term = li.dataset.term || li.textContent.trim();

    // Cancel any pending debounced search (e.g. from typing just "a")
    clearTimeout(searchT);

    // Put the chosen term in the input
    glossaryInput.value = term;

    // Clicking a suggestion should lock us into an exact match
    exactMode = true; // NEW

    // Hide dropdown
    hideSuggestions();

    // Immediately filter by this exact term (lowercased)
    setViewSearch(term.toLowerCase()); // NEW: use search view with exactMode on

    // Scroll results into view with offset (so it doesn't hide under sticky header)
    setTimeout(() => {
      // Prefer the single item if it exists, otherwise scroll to the whole glossary block
      const single = document.querySelector('.glossary-item--single');
      const targetEl = single || glossaryDisplay;

      const OFFSET = 260; // tweak this (e.g. 120, 160) to match your header height

      const rect = targetEl.getBoundingClientRect();
      const top  = rect.top + window.pageYOffset - OFFSET;

      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }, 50);
  });

  // ---------- pagination/view state ----------
  const PAGE_SIZE = 50;
  let visibleCount = PAGE_SIZE; // how many items to show in current view
  let viewMode = { type: 'all', letter: null, query: '' };
  // types: 'all' | 'letter' | 'search'

  function setViewAll() {
    viewMode = { type: 'all', letter: null, query: '' };
    visibleCount = PAGE_SIZE;
    renderView();
  }
  function setViewLetter(letter) {
    viewMode = { type: 'letter', letter: (letter || 'ALL').toUpperCase(), query: '' };
    visibleCount = PAGE_SIZE;
    exactMode = false; // NEW: reset exact mode when switching by letter
    renderView();
  }
  function setViewSearch(q) {
    viewMode = { type: 'search', letter: null, query: (q || '').trim().toLowerCase() };
    visibleCount = PAGE_SIZE;
    renderView();
  }

  function getBaseEntries() {
    if (viewMode.type === 'letter') {
      if (viewMode.letter === 'ALL') return allEntries;
      return allEntries.filter(e => {
        const term = (e.term || '').trim();
        return term.toUpperCase().startsWith(viewMode.letter);
      });
    }
    if (viewMode.type === 'search') {
      const q = viewMode.query;
      if (!q) return allEntries;
      return allEntries.filter(e => {
        const term = (e.term || '').trim().toLowerCase();
        if (!term) return false;
        if (exactMode) {
          // NEW: exact match when exactMode is enabled
          return term === q;
        }
        // default: prefix search
        return term.startsWith(q);
      });
    }
    return allEntries; // 'all'
  }

  function getEntriesToRender() {
    const base = getBaseEntries();
    return { base, slice: base.slice(0, Math.max(0, visibleCount)) };
  }

  // ---------- utils ----------
  function escapeHTML(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // ---------- rendering (single vs grouped) ----------

  // NEW: render a single entry WITHOUT letter heading
  function renderSingleEntry(entry) {
    glossaryDisplay.innerHTML = `
      <div class="glossary-item glossary-item--single">
        <h5>${escapeHTML(entry.term || '')}</h5>
        <p>${escapeHTML(entry.definition || '')}</p>
      </div>
    `;
    renderedLetters.clear();
    recalcLetterBarTop();
    updateLetterBarFixed();
  }

  function renderGlossaryGrouped(entries, append = false) {
    if (!append) {
      glossaryDisplay.innerHTML = '';
      renderedLetters.clear();
    }
    const grouped = {};
    entries.forEach(entry => {
      if (!entry?.term) return;
      const term = (entry.term || '').trim();
      if (!term) return;
      const letter = term[0].toUpperCase();
      (grouped[letter] ||= []).push({
        ...entry,
        term // store trimmed term
      });
    });

    Object.keys(grouped).sort().forEach(letter => {
      let section = document.getElementById(`letter-${letter.toLowerCase()}`)?.parentElement;
      if (!section) {
        section = document.createElement('div');
        section.className = 'letter-section';
        const heading = document.createElement('h2');
        heading.className = 'letter-title';
        heading.id = `letter-${letter.toLowerCase()}`;
        heading.textContent = letter;
        section.appendChild(heading);
        glossaryDisplay.appendChild(section);
        renderedLetters.add(letter);
      }
      const html = grouped[letter].map(entry =>
        `<div class="glossary-item">
           <h5>${escapeHTML(entry.term)}</h5>
           <p>${escapeHTML(entry.definition || '')}</p>
         </div>`
      ).join('');
      section.insertAdjacentHTML('beforeend', html);
    });

    // after (re)render, recompute sticky anchor
    recalcLetterBarTop();
    updateLetterBarFixed();
  }

  function renderView() {
    const { base, slice } = getEntriesToRender();

    if (viewMode.type === 'letter') {
      renderGlossaryGrouped(slice);
    } else if (base.length === 1) {
      renderSingleEntry(base[0]);
    } else {
      renderGlossaryGrouped(slice);
    }

    const remaining = Math.max(0, base.length - slice.length);
    const hasMore = remaining > 0 && base.length > 1;
    loadMoreBtn.style.display = hasMore ? '' : 'none';
    if (loadAllBtn) loadAllBtn.style.display = hasMore ? '' : 'none';
  }

  // ---------- filtering (search) ----------
  function filterBySearch(query) {
    const q = (query || '').trim().toLowerCase();

    // No query → show full list (capped to PAGE_SIZE)
    if (!q) {
      exactMode = false; // NEW: reset exact mode when clearing search
      setViewAll();
      return;
    }

    // Normal debounced typing should use prefix behavior
    exactMode = false; // NEW: typing = prefix mode

    // Check if there are any prefix matches
    const hasMatches = allEntries.some(e => {
      const term = (e.term || '').trim().toLowerCase();
      return term.startsWith(q);
    });

    // If no matches, fall back to full list (capped)
    if (!hasMatches) {
      setViewAll();
      return;
    }

    // Otherwise, show the search view (prefix mode)
    setViewSearch(q);
  }

  // ---------- suggestions (live search) ----------
  function hideSuggestions() {
    suggestionsList.classList.remove('is-visible');
    suggestionsList.innerHTML = '';
  }

  function updateSuggestions(query) {
    const q = (query || '').toLowerCase();
    suggestionsList.innerHTML = '';
    if (!q) { hideSuggestions(); return; }

    const matches = allEntries
      .map(entry => {
        const raw = typeof entry.term === 'string' ? entry.term : '';
        const term = raw.trim();
        return { ...entry, term };
      })
      .filter(entry =>
        entry.term &&
        entry.term.toLowerCase().startsWith(q)
      );

    if (!matches.length) { hideSuggestions(); return; }
    suggestionsList.classList.add('is-visible');

    matches.forEach(entry => {
      const term = entry.term || '';
      const head = term.slice(0, q.length);
      const tail = term.slice(q.length);

      const li = document.createElement('li');
      li.className = 'glossary-suggestion';

      // store term for delegated click handler
      li.dataset.term = term;

      li.innerHTML = `
        <span class="match">
          <strong>${escapeHTML(head)}</strong>${escapeHTML(tail)}</strong>
        </span>
      `;

      suggestionsList.appendChild(li);
    });
  }

  // Optional: Enter selects first suggestion
  function maybeSelectFirstSuggestion(ev) {
    if (ev.key !== 'Enter') return;
    const first = suggestionsList.querySelector('.glossary-suggestion');
    if (first) { first.click(); ev.preventDefault(); }
  }

  // click outside to close
  document.addEventListener('click', (e) => {
    const within = e.target === glossaryInput || suggestionsList.contains(e.target);
    if (!within) hideSuggestions();
  });
  glossaryInput.addEventListener('blur', () => setTimeout(hideSuggestions, 150));

  // ---------- init ----------
  fetch(GLOSSARY_URL)
    .then(r => r.json())
    .then(data => {
      // normalize / trim terms once on load
      const raw = Array.isArray(data?.data) ? data.data : [];
      allEntries = raw.map(entry => {
        const term = typeof entry.term === 'string' ? entry.term.trim() : entry.term;
        return { ...entry, term };
      });
      setViewAll(); // renders with PAGE_SIZE cap
      initScrollSpy();
    })
    .catch(err => {
      console.error('Failed to load glossary JSON:', err);
      glossaryDisplay.innerHTML = '<p>Unable to load glossary right now.</p>';
    });

  // ---------- Letter bar: switch to that letter (capped), then scroll with -240 offset ----------
  LETTER_ANCHORS.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();

    const letter = (link.dataset.letter || 'ALL').toUpperCase();

    // Reset input + suggestions
    glossaryInput.value = '';
    hideSuggestions();

    // 🆕 activate the clicked .letter-box
    setActiveLetter(letter);

    // Apply filtered view
    setViewLetter(letter);

    // Scroll into view w/ offset
    setTimeout(() => {
      let scrollTarget = (letter === 'ALL')
        ? glossaryDisplay
        : document.getElementById(`letter-${letter.toLowerCase()}`);

      if (scrollTarget) {
        const offsetTop = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 300;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    }, 100);
  });
});



  // ---------- Search (debounced) + suggestions ----------
  glossaryInput.addEventListener('input', function () {
    clearTimeout(searchT);
    const valNow = this.value.trim();

    // typing switches back to prefix mode
    exactMode = false; // NEW

    clearActiveLetter();

    updateSuggestions(valNow);       // live suggestions

    // Show/hide clear button
    if (glossaryClear) {
      glossaryClear.classList.toggle('visible', !!valNow);
    }

    searchT = setTimeout(() => { filterBySearch(valNow); }, 150);
  });

  if (glossaryClear) {
    glossaryClear.addEventListener('click', () => {
      glossaryInput.value = '';
      glossaryClear.classList.remove('visible');

      exactMode = false;  // NEW: reset exact mode
      hideSuggestions();
      setViewAll();       // reset glossary view back to full list
    });
  }

  glossaryInput.addEventListener('keydown', maybeSelectFirstSuggestion);

  // ---------- Load More / Load All ----------
  loadMoreBtn.addEventListener('click', () => {
    visibleCount += PAGE_SIZE;
    renderView();
  });
  if (loadAllBtn) {
    loadAllBtn.addEventListener('click', () => {
      visibleCount = Number.MAX_SAFE_INTEGER; // show all for current view
      renderView();
    });
  }

  // ---------- Simple window-based sticky for .letter-bar / .letter-box ----------
  let letterBarInitialTop = null;
  const STICKY_OFFSET = 110; // change to 120 if you prefer

  function recalcLetterBarTop() {
    if (!LETTER_BAR) return;
    const rect = LETTER_BAR.getBoundingClientRect();
    letterBarInitialTop = rect.top + window.scrollY;
  }
  function updateLetterBarFixed() {
    if (!LETTER_BAR) return;

    const stickyTop = window.innerWidth <= 768 ? 68 : STICKY_OFFSET;
    const addPoint = stickyTop + 0;
    const removePoint = stickyTop + 70;

    const barTop = LETTER_BAR.getBoundingClientRect().top;

    if (barTop <= addPoint) {
      if (!LETTER_BAR.classList.contains('is-fixed')) {
        LETTER_BAR.style.minHeight = `${LETTER_BAR.offsetHeight}px`;
        LETTER_BAR.classList.add('is-fixed');
      }
    } else if (barTop >= removePoint) {
      LETTER_BAR.classList.remove('is-fixed');
      LETTER_BAR.style.minHeight = '';
    }
  }
  window.addEventListener('scroll', updateLetterBarFixed, { passive: true });
  window.addEventListener('resize', () => { recalcLetterBarTop(); updateLetterBarFixed(); });
  window.addEventListener('load',   () => { recalcLetterBarTop(); updateLetterBarFixed(); });
});
